import { X } from "lucide-react";
import React, { useEffect, useRef } from "react";
import { isMobileScreen } from "../../lib/utils";
import { createPortal } from "react-dom";

type DialogProps = {
  isOpen: boolean;
  onClose: () => void;
  header: string;
  children: React.ReactNode;
  footerButtons?: {
    name: string;
    onClick: () => void;
    className?: string;
    disabled: boolean;
    icon?: React.ReactNode;
  }[];
  bodyClassName?: string;
  toolTipComponent?: React.ReactNode;
  mainClassName?: string;
};

const SortupDialog: React.FC<DialogProps> = ({
  isOpen,
  onClose,
  header,
  children,
  footerButtons,
  bodyClassName = "",
  toolTipComponent,
  mainClassName = "",
}) => {
  const dialogRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  // const handleOutsideClick = (event: React.MouseEvent) => {
  //   if (
  //     dialogRef.current &&
  //     !dialogRef.current.contains(event.target as Node)
  //   ) {
  //     onClose();
  //   }
  // };

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999] bg-black bg-opacity-40"
      // onClick={handleOutsideClick}
    >
      <div
        ref={dialogRef}
        className={`bg-white rounded-lg shadow-lg flex flex-col max-h-[80vh] overflow-hidden ${
          isMobileScreen ? "w-[90vw]" : "max-w-[60vw]"
        }`}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-white bg-customGreenColor text-white overflow-hidden">
          <h2 className="text-lg font-medium flex items-center">
            {header}
            {toolTipComponent}
          </h2>
          <button onClick={onClose} className="text-xl font-bold text-gray-500">
            <X className="h-5 w-5 text-white" />
          </button>
        </div>

        {/* Body */}
        <div
          className={`p-4 overflow-y-auto grow ${bodyClassName}`}
          style={{
            maxHeight: "calc(80vh - 8rem)",
            maxWidth: isMobileScreen ? "100%" : "calc(60vw - 2rem)",
          }}
        >
          {children}
        </div>

        {/* Footer */}
        {footerButtons && (
          <div className="flex justify-start p-4 border-t gap-2">
            {footerButtons?.map((button, index) => (
              <button
                key={index}
                type="button"
                onClick={button.onClick}
                disabled={button.disabled}
                className={`flex text-sm font-normal items-center justify-center bg-customGreenColor px-6 py-2 gap-1 rounded-lg ${button.className}`}
              >
                {button.icon && <span className="mr-2">{button.icon}</span>}
                {button.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default SortupDialog;
